var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { createContext, useContext, useState, } from 'react';
import FormInput from './FormInput';
export function useForms(_a) {
    var initialValues = _a.initialValues, validation = _a.validation, onSubmit = _a.onSubmit;
    var _b = __read(useState(false), 2), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var _c = __read(useState(initialValues), 2), values = _c[0], setValues = _c[1];
    var _d = __read(useState({}), 2), errors = _d[0], setErrors = _d[1];
    function handleChange(e) {
        e.persist();
        setValues(function (curr) {
            var copy = __assign({}, curr);
            var key = e.target.name;
            if (key in copy) {
                copy[key] = e.target.value;
            }
            else {
                throw new Error("Setup Error: Check your form field name, key \"".concat(key, "\" does not exist on object ").concat(values));
            }
            return copy;
        });
    }
    function handleSubmit(e) {
        return __awaiter(this, void 0, void 0, function () {
            var errors;
            return __generator(this, function (_a) {
                e.preventDefault();
                errors = validation(values);
                setErrors(errors);
                if (Object.keys(errors).length) {
                    return [2 /*return*/];
                }
                setIsSubmitting(true);
                onSubmit(values, {
                    setIsSubmitting: function (value) {
                        setIsSubmitting(value);
                    },
                });
                return [2 /*return*/];
            });
        });
    }
    return {
        values: values,
        errors: errors,
        isSubmitting: isSubmitting,
        handleChange: handleChange,
        handleSubmit: handleSubmit,
    };
}
var FormsContext = createContext(undefined);
var FormsProvider = FormsContext.Provider;
var FormsConsumer = FormsContext.Consumer;
export function Forms(props) {
    var forms = useForms(props);
    var children = props.children;
    return React.createElement(FormsProvider, { value: forms }, typeof children === 'function' ? children(forms) : children);
}
function useFormsContext() {
    return useContext(FormsContext);
}
function useFormField(props) {
    var forms = useFormsContext();
}
function FormField(props) {
    var forms = useFormField(props);
    var name = props.name, type = props.type, label = props.label;
    return React.createElement(FormInput, { label: label, name: name, type: type, value: '' });
}
